<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />


  <div class="page">
    <div>
      <div>
        <div class="flex align-items-center flex-column align-items-center" style="100vh">
          <div class="button-wrapper mb-2">
            <span class="label">{{fileToUpload.length > 0 ? fileToUpload[0].name : 'Carica File' }}</span>
            <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
          </div>
          <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
          <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
        </div>
        <div class="text-center">
          <!-- <small>Formati consentiti: {{allowedType.join(", ")}}</small> -->
          <small>Formati consentiti: {{Object.keys(allowedType).join(', ')}}</small>
        </div>
      </div>
    </div>
  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import { ref, getCurrentInstance} from 'vue';
import Service from '@/services/ask-operation/operation-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup() {
    const page = { name: 'pods-rcu-unico'}
    const loader = ref(false)
    const toast = useToast();

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const fileToUpload = ref([])
    const allowedType = {
      'zip' : 'application/x-zip-compressed;application/zip',
    } 
    const validationErrors = ref({})
    const submitted = ref(false)
      

    const handleFileUpload = (evt) => {
      fileToUpload.value = []
      evt.preventDefault()
      submitted.value = false;
      fileToUpload.value = self.refs.file.files
    }
      
    const onOkButton = () => {
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm() ) {
         
        loader.value = true
        service.createRcuUnicoFile(fileToUpload.value)
        .catch(() => {
          toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nell \' analisi del file ', group: page.name});
        })
        .finally(()=>{
          loader.value = false
          self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

      }
    }
    


    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    const validateForm = () => {

      if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => (Object.values(allowedType).join(',').replace(';',',').split(",").includes(file.type)), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      page,
      fileToUpload,
      allowedType,
      loader,
      handleFileUpload,
      validationErrors, 
      submitted,
      onCancelButton,
      onOkButton
    }
  }
}


</script>

<style scoped>
.page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
.button-wrapper {
  position: relative;
  width: 290px;
  text-align: center;
  padding: 12px 20px
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #aaaaaa;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0); 
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0);
}

#upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 50px;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
</style>

